import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsInfoView} from '@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoView';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';

export class FreeSpinsInfoModule extends Module<FreeSpinsInfoView> {
	public restore(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;

		if (logic.isFreeSpinsStarted && logic.freeSpinsPlayed > 0) {
			this.view.show();
			this.updateFreeSpinInformation();
		}
	}

	protected enterFirstState(): void {
		this.view.hide();
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.FREE_SPINS_INFO_VIEW_MOBILE);
		} else {
			this.setView(Views.FREE_SPINS_INFO_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		// this.on(ReelsEvents.SPIN_ENDED, this.onSpinEnded, 1);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted, 1);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);

		this.on(FlowModuleEvents.FREE_SPINS_FINISHED, this.onFreeSpinsFinished);
	}

	protected onFreeSpinsContinueClicked(): void {
		this.view.show();
		this.updateMultiplier(1);
		this.updateFreeSpinInformation();
	}

	protected onFreeSpinsOutroStarted(): void {
		this.view.hide();
	}

	protected updateMultiplier(multiplier: number): void {
		this.view.multiplierFreeSpins = multiplier;
	}

	protected updateSpinsLeft(): void {
		if (this.logic.freeSpinsPlayed === this.logic.freespinsTotalAwarded) {
			this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed);
		} else {
			this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed + 1);
		}
	}

	protected onFreeSpinsFinished(): void {
		this.updateFreeSpinInformation();
	}

	protected updateFreeSpinInformation(): void {
		this.updateSpinsLeft();
	}

	protected onMultiplierUpdated(event: string, multiplier: number): void {
		this.updateFreeSpinInformation();
		this.updateMultiplier(multiplier);
	}

	protected onFreeSpinsIntroFinished(): void {
		this.updateFreeSpinInformation();
	}

	/*protected onSpinEnded(): void {
		this.updateFreeSpinInformation();
	}*/

	protected onSpinStarted(): void {
		this.updateFreeSpinInformation();

	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoModule.ts